import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchService } from '@nucleus/ui-base';
import { ServiceHandler } from '@nucleus/ui-base';
import { PageResult } from '@nucleus/ui-base';
import { Page, QuerySortDirection } from '@nucleus/ui-base';
import { FilterRequest } from '../filter-request';
import { NucleusAccessRequestFilter } from '@nucleus/access-request-ui';
import {
  PaginatedFilterRequestUserAccessRequestFilter,
  UserAccessRequest as AccessRequest,
  UserAccessRequestControllerService,
} from '@nucleus/user-ui';
import { RequestHandler } from '../request-handler';


@Injectable({
  providedIn: 'root'
})
export class AccessRequestService implements SearchService<AccessRequest, NucleusAccessRequestFilter> {

  constructor(
    private api: UserAccessRequestControllerService,
    private requestHandler: RequestHandler,
  ) { }


  search(handler: ServiceHandler<AccessRequest[]>): void {
  }

  searchPaginated(handler: ServiceHandler<PageResult<AccessRequest>>, pageSize: number, pageNumber: number, softField: string, sortDirection: QuerySortDirection) {
  }

  filterPaginated(handler: ServiceHandler<PageResult<AccessRequest>>, pageSize: number, pageNumber: number, softField: string, sortDirection: QuerySortDirection, filter: NucleusAccessRequestFilter): void {
    let request = new FilterRequest<NucleusAccessRequestFilter>(filter);
    request.page.pageSize = pageSize;
    request.page.pageNumber = pageNumber;
    request.page.sortDirection = sortDirection;
    request.page.sortField = softField;

    this.filter(handler, request.filter, request.page);
  }


  filter(handler: ServiceHandler<PageResult<AccessRequest>>, filter: NucleusAccessRequestFilter, page?: Page, _clientId?: string): void {
    const request = new FilterRequest<NucleusAccessRequestFilter>(filter);
    if (page) { request.page = page; }
    this.requestHandler.handleRequest(
      this.api.filter1(this.toApiFilterRequest(request)) as unknown as Observable<PageResult<AccessRequest>>,
      handler,
      false,
    );
  }

  private toApiFilterRequest(request: FilterRequest<NucleusAccessRequestFilter>): PaginatedFilterRequestUserAccessRequestFilter {
    return {
      page: {
        pageSize: request.page?.pageSize,
        pageNumber: request.page?.pageNumber,
        sortField: request.page?.sortField,
        sortDirection: request.page?.sortDirection as unknown as string,
      },
      filter: { ...(request.filter as any) },
    };
  }


  approveAccessRequest(id: number, handler: ServiceHandler<void>): void {
    this.requestHandler.handleRequest(this.api.approve(id), handler, true);
  }

  rejectAccessRequest(id: number, handler: ServiceHandler<void>): void {
    this.requestHandler.handleRequest(this.api.reject(id), handler, true);
  }


  getPDFReport(handler: ServiceHandler<Blob>, request: FilterRequest<NucleusAccessRequestFilter>) {
    this.requestHandler.handleRequest(this.api.createPdfReport1(this.toApiFilterRequest(request)), handler, true);
  }


  getXLSReport(handler: ServiceHandler<Blob>, request: FilterRequest<NucleusAccessRequestFilter>) {
    this.requestHandler.handleRequest(this.api.createExcelReport1(this.toApiFilterRequest(request)), handler, true);
  }


  getCSVReport(handler: ServiceHandler<Blob>, request: FilterRequest<NucleusAccessRequestFilter>) {
    this.requestHandler.handleRequest(this.api.createCSVReport1(this.toApiFilterRequest(request)), handler, true);
  }
}
